import Foundation from 'foundation-sites';

export function isMobile() { 
    return Foundation.MediaQuery.upTo("medium");
}